<template>
  <div class="wrapper">
    <div class="logo">
      <img alt="logo" :src="referalLogo" />
    </div>
    <div class="btnsWrapper">
      <p>Скачайте приложение и начните получать бонусы!</p>
      <div class="btns">
        <button
          @click="clickBtn(item)"
          v-for="item of formatedButtonLinks"
          :key="item.type"
        >
          <img alt="iconbtn" :src="item.logo" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReferalStores",

  data() {
    return {
      referalLogo: process.env.VUE_APP_REFERAL_LOGO,
    };
  },

  props: {
    buttonLinks: {
      type: Array,
      default: () => [],
    },

    userData: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    formatedButtonLinks() {
      return this.buttonLinks.filter(
        (item) => item.url && item.url.toLowerCase() !== "false"
      );
    },
  },

  methods: {
    backBtn() {
      this.$emit("back");
    },

    async clickBtn(item) {
      window.open(item.url);
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.logo {
  flex-shrink: 0;
  width: 88px;
  height: 88px;
  margin: 27px auto 0 auto;

  border-radius: 16px;
  overflow: hidden;

  img {
    display: block;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}

.btnsWrapper {
  margin: 36px 6px 0 6px;
  padding: 24px 16px;
  height: 100%;

  p {
    font-size: 14px;
    line-height: 21px;
    font-weight: 700;
    text-align: center;
    color: #25282b;
  }

  .btns {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;
    padding: 16px;
    border-radius: 16px;
    box-shadow: 0px 24px 48px 0 rgba(0, 0, 0, 0.2);
  }

  button {
    height: 43px;
    border-radius: 8px;
    border: none;
    background: black;
    color: white;
    cursor: pointer;
  }
}
</style>
